<template>
  <div class="thank-you-container" :style="{ backgroundImage: 'url(' + images.thankyou + ')'}"></div>
</template>

<script>
import Navbar from "@/components/Navbar";
export default {
  name: "Thankyou",
  props: ["images"],
  components: { Navbar }
};
</script>

<style scoped>
.thank-you-container {
  display: flex;
  width: 100vw;
  height: 100vh;
  justify-content: center;
  align-items: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Thankyou.vue